<div class="assign-container fluid-container veevavault-docs">
    <div class="top-right-div">
        <div class="top-row">
            <div class="left-titl-buton ">
                <div  class="back-btn-new" (click)="backbutton()">
                    <img  src="../../../assets/images/back_button_popup.svg" alt="Back-Button">
                </div>
                <div class="title">
                    {{ breadcrumb.product_name || 'NA' }}
                </div>
                <!-- <div *ngIf="isSomeSelected()" class="dropdown-container">
                    <mat-form-field>
                        <mat-select placeholder="Select Action" [(value)]="selectedActionValue">
                          <mat-option *ngFor="let action of actions" [value]="action.value">{{ action.name }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    <button mat-raised-button color="primary" (click)="submitAction()" [disabled]="!selectedActionValue">Submit</button>
                  </div> -->
                <div class="custom-toggle">
                    <button [class.active]="status === 'Active'" (click)="filterDataStatus('Active')">Active</button>
                    <button [class.active]="status === 'Inactive'" (click)="filterDataStatus('Inactive')">De-active</button>
                  </div>
                  
            </div>

            <div class="right-filter">
                <div class="filter-search-wrapper">
                    <input matInput #searchInput placeholder="Search with ..." class="filter-search"
                        (input)="applyFilter(searchInput.value)">
                    <i class="fa fa-search search-icon"></i>
                </div>
                
                <div *ngIf="showNoSearchResultsMessage">
                    No search results found.
                </div>
            </div>
        </div>
        <div class="sec-row">
            <div class="sr-left-div">
                <!-- <span> {{ filteredDataSource.data.length }} Files</span> -->
                <!--  <span>Last Updated on 12-12-2024 07:01 AM</span> -->
            </div>
        <div class="breadcrumb">
                <ul>
                    <li>{{ breadcrumb.source_name }}</li>
                    <li>></li>
                    <li>{{ breadcrumb.source_path }}</li>
                </ul>
            </div>
            <span> {{ filteredDataSource.data.length }} Files</span>
            <!-- <div class="right-filter">
            <div class="filter-search-wrapper">
                <input matInput #searchInput placeholder="Search with ..." class="filter-search"
                    (input)="applyFilter(searchInput.value)">
                <i class="fa fa-search search-icon"></i>
            </div>
            
            <div *ngIf="showNoSearchResultsMessage">
                No search results found.
            </div>
            </div> -->
            
        </div>
        <div class="bottom-table">
            <div class="overfloxauto">
                <table  mat-table [dataSource]="filteredDataSource" matSort 
                (matSortChange)="sortData($event)" class="assignee-table mat-elevation-z7">
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef width="50px">
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                                        [checked]="isAllSelected()"
                                        [indeterminate]="isSomeSelected()"
                                        [disabled]="status !== 'Active'">
                        </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? toggleSelection(row) : null"
                                        [checked]="selection.isSelected(row)"
                                        [disabled]="status !== 'Active'">
                        </mat-checkbox>
                        </td>
                    </ng-container>
                    <!-- 
                    <ng-container matColumnDef="doc_id__v">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                            Document ID
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.doc_id__v}} </td>
                    </ng-container> -->
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th" title=" Document Number" >
                           ID
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.id}} </td>
                    </ng-container>
                    <ng-container matColumnDef="sharepoint_path_id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th" title=" Document Name" >
                            Datasource Path ID
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td" title="{{element.sharepoint_path_id}}"> {{element.sharepoint_path_id}} </td>
                    </ng-container>
                    <ng-container matColumnDef="file_name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th" >
                           File name
                        <td mat-cell *matCellDef="let element" class="tab-td text-format-none" title="{{element.file_name}}"> {{element.file_name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                           Process status
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td" title="{{element.status}}">{{element.status}} </td>
                    </ng-container>
                    <ng-container matColumnDef="activation_date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                            Activation Date
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td" title="{{element.owner}}"> {{ convertUtcToLocal(element.activation_date) | date: 'MM-dd-yyyy hh:mm a' }} </td>
                    </ng-container>
                    <ng-container matColumnDef="updated_date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th" >
                           last Updated date
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td" title="{{element.process_end_time}}"> {{ convertUtcToLocal(element.updated_date) | date: 'MM-dd-yyyy hh:mm a' }} </td>
                     </ng-container>
                     
                    <!-- <ng-container matColumnDef="version_id__v">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                            Version
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td">
                            {{ element.version_id__v }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="status__v">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                            Veeva-Vault-Status
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td" title="{{element.status__v}}">
                            {{ element.status__v }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="document_priority">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Priority </th>
                        <td mat-cell *matCellDef="let element" class="tab-td">
                          <ng-container *ngIf="element.document_priority === '1'">P1</ng-container>
                          <ng-container *ngIf="element.document_priority === '2'">P2</ng-container>
                          <ng-container *ngIf="element.document_priority === '3'">P3</ng-container>
                        </td>
                      </ng-container>
                    <ng-container matColumnDef="process_status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                            Process Status
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td" title="{{element.process_status}}"> {{element.process_status}} </td>
                    </ng-container>  -->
                  
                   

                    <!-- <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> Priority </th>
                        <td mat-cell *matCellDef="let row">
                          <mat-form-field>
                            <mat-select [(value)]="row.selectedAction" (selectionChange)="onActionChange(row)">
                              <mat-option *ngFor="let action of actions" [value]="action">{{ action }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                      </ng-container> -->
                    <!-- <ng-container matColumnDef="process_end_time">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                            End Time
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td">
                            {{ element.process_end_time }}
                        </td>
                    </ng-container> -->

                    <!-- <ng-container matColumnDef="type__v">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                            Type
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.type__v}} </td>
                    </ng-container>
                    <ng-container matColumnDef="updated_by">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            class="tab-th">
                           Updated by
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td">{{element.updated_by}} </td>
                    </ng-container> -->
                   
                    <!-- <ng-container matColumnDef="status-1">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="status" sortActionDescription="Sort by status" class="tab-th">
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.status}} </td>
                    </ng-container> -->
                   
                      <!-- <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="tab-th" title="Actions">Actions</th>
                        <td mat-cell *matCellDef="let row" class="tab-td">
                       
                          <button mat-icon-button [matMenuTriggerFor]="menu" [matMenuTriggerData]="row">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                         
                          <mat-menu #menu="matMenu">
                            <button mat-menu-item *ngIf="toLower(row.status) === 'active'" (click)="changeStatus(row, 'Inactive')">
                              Inactivate
                            </button>
                            <button mat-menu-item *ngIf="toLower(row.status) === 'inactive'" (click)="changeStatus(row, 'Active')">
                              Activate
                            </button>
                          </mat-menu>
                        </td>
                      </ng-container> -->
                     


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="rowClicked(row)"></tr>

                </table>
                

                <!-- <div *ngIf="isSomeSelected()" class="dropdown-container">
                    <mat-form-field>
                        <mat-select placeholder="Select Action" [(value)]="selectedActionValue">
                          <mat-option *ngFor="let action of actions" [value]="action.value">{{ action.name }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    <button mat-raised-button color="primary" (click)="submitAction()" [disabled]="!selectedActionValue">Submit</button>
                  </div> -->
                <mat-paginator [pageSizeOptions]="[5,10,15,20,50]" showFirstLastButtons
                    aria-label="Select page of periodic elements">
                </mat-paginator>

            </div>
            
        </div>
        <div class="btn-areas" *ngIf="status === 'Active'">
            <!-- <button mat-raised-button color="primary" [disabled]="!selection.hasValue()" (click)="changeStatusOfSelectedRows()">{{ status === 'Active' ? 'Deactivate': 'Activate'}}</button> -->
            <button mat-raised-button color="primary" [disabled]="!selection.hasValue()" (click)="changeStatusOfSelectedRows()">Deactivate</button>

        </div>
    </div>

</div>